import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

// Check if running as native app
export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'ios', 'android', or 'web'

// Initialize native features
export const initializeNativeApp = async () => {
    if (!isNative) return;

    try {
        // Set status bar style
        await StatusBar.setStyle({ style: Style.Light });
        
        if (platform === 'android') {
            await StatusBar.setBackgroundColor({ color: '#1a3a2f' });
        }

        // Hide splash screen after app is ready
        await SplashScreen.hide();
    } catch (error) {
        console.error('Error initializing native features:', error);
    }
};

// Handle back button on Android
export const setupBackButtonHandler = (callback) => {
    if (!isNative) return;

    App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
            window.history.back();
        } else {
            callback?.();
        }
    });
};

// Handle app state changes (foreground/background)
export const setupAppStateHandler = (onResume, onPause) => {
    if (!isNative) return;

    App.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
            onResume?.();
        } else {
            onPause?.();
        }
    });
};

// Get app info
export const getAppInfo = async () => {
    if (!isNative) return null;

    try {
        const info = await App.getInfo();
        return info;
    } catch (error) {
        console.error('Error getting app info:', error);
        return null;
    }
};

// Exit app (Android only)
export const exitApp = () => {
    if (platform === 'android') {
        App.exitApp();
    }
};
